var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.208 442.942a8.529 8.529 0 0 0 10.517-2.754l153.6-213.333a8.535 8.535 0 0 0-6.925-13.521h-76.458l33.537-134.467a8.53 8.53 0 0 0-4.688-9.808c-3.733-1.717-8.133-.571-10.517 2.754l-153.6 213.333a8.535 8.535 0 0 0 6.925 13.521h76.458l-33.538 134.467a8.535 8.535 0 0 0 4.689 9.808zM249.263 292.2a8.534 8.534 0 0 0-8.279-10.6h-70.725l117.912-163.767L262.737 219.8a8.534 8.534 0 0 0 8.279 10.6h70.725L223.829 394.167 249.263 292.2z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.467 247.467a8.533 8.533 0 0 0-8.533 8.533c0 131.75-107.183 238.933-238.933 238.933-70.547 0-137.665-31.642-182.867-85.333h46.333a8.533 8.533 0 0 0 0-17.066H51.2a8.533 8.533 0 0 0-8.533 8.533v68.267a8.533 8.533 0 0 0 17.066 0v-49.146C108.161 477.95 180.235 512 256 512c141.158 0 256-114.842 256-256a8.533 8.533 0 0 0-8.533-8.533zM256 17.067c70.547 0 137.665 31.642 182.867 85.333h-46.333a8.533 8.533 0 0 0 0 17.066H460.8a8.533 8.533 0 0 0 8.533-8.533V42.667a8.533 8.533 0 0 0-17.066 0v49.146C403.839 34.05 331.765 0 256 0 114.842 0 0 114.842 0 256a8.533 8.533 0 0 0 17.066 0C17.067 124.25 124.25 17.067 256 17.067z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.ee9ae8d7f71957eae7d908b03526d057.svg";
export { ForwardRef as ReactComponent };